import { createFileRoute } from "@tanstack/react-router";
import { Suspense, lazy } from "react";
import { WorkspaceHeader } from "@/components/WorkspaceHeader";
import { HeaderChatLink, HeaderMyWorkLink } from "@/components/crm/HeaderChatLink";

const TeamChat = lazy(() =>
  import("@/components/crm/TeamChat").then((m) => ({ default: m.TeamChat })),
);

export const Route = createFileRoute("/crm/chat")({
  head: () => ({
    meta: [
      { title: "Team Chat — CRM" },
      { name: "description", content: "Internal CRM team chat for admins and sales reps." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: TeamChatPage,
});

function TeamChatPage() {
  return (
    <div
      className="fixed inset-0 flex flex-col overflow-hidden"
      style={{ background: "#f4f6f8", fontFamily: "'Poppins', system-ui, sans-serif" }}
    >
      <WorkspaceHeader
        current="crm"
        end={
          <div className="flex items-center gap-1">
            <HeaderMyWorkLink variant="chrome" />
            <HeaderChatLink variant="chrome" />
          </div>
        }
      />
      <main className="flex-1 min-h-0">
        <Suspense
          fallback={
            <div className="h-full grid place-items-center text-sm text-[#6c757d]">Loading chat…</div>
          }
        >
          <TeamChat fullPage />
        </Suspense>
      </main>
    </div>
  );
}
